module.exports = __webpack_public_path__ + "img/15.147d2449.png";